import { createSlice } from '@reduxjs/toolkit';

const optionsSlice = createSlice({
	name: 'options',
	initialState: {
		coordinadors: [],
		languages: [],
		accountsBank: [],
		colors: [],
		levels: [],
		teachers: [],
		coursesList: [],
		coursesListByIdUser: [],
		identifiers: [],
		adminUsers: [],
		studentsNotInCourse: [],
		loadingStudentsNotInCourse: false,
		loading: false,
	},
	reducers: {
		optionsStart: (state) => {
			state.loading = true;
		},
		optionsCoordinadorsSuccess: (state, { payload: { data } }) => {
			state.loading = false;
			state.coordinadors = data;
		},
		optionsLanguagesSuccess: (state, { payload: { data } }) => {
			state.loading = false;
			state.languages = data;
		},
		optionsColorsSuccess: (state, { payload: { data } }) => {
			state.loading = false;
			state.colors = data;
		},
		optionsLevelsSuccess: (state, { payload: { data } }) => {
			state.loading = false;
			state.levels = data;
		},
		optionsTeachersSuccess: (state, { payload: { data } }) => {
			state.loading = false;
			state.teachers = data;
		},
		optionsAccountsBankSuccess: (state, { payload: { data } }) => {
			state.loading = false;
			state.accountsBank = data;
		},
		optionsCourseListSuccess: (state, { payload: { data } }) => {
			state.loading = false;
			state.coursesList = data;
		},
		optionsCourseListOpenByIdUserSuccess: (state, { payload: { data } }) => {
			state.loading = false;
			state.coursesListByIdUser = data;
		},
		optionsCourseIdentifiersSuccess: (state, { payload: { data } }) => {
			state.loading = false;
			state.identifiers = data;
		},
		optionsAdminUserSuccess: (state, { payload: { data } }) => {
			state.loading = false;
			state.adminUsers = data;
		},
		optionsFailure: (state) => {
			state.loading = false;
		},
		optionsSearchStudentNotInCourseStart: (state) => {
			state.loadingStudentsNotInCourse = true;
		},
		optionsSearchStudentNotInCourseSuccess: (state, { payload: { data } }) => {
			state.loadingStudentsNotInCourse = false;
			state.studentsNotInCourse = data;
		},
		optionsSearchStudentNotInCourseFailure: (state) => {
			state.loadingStudentsNotInCourse = false;
		},
	},
});

export const {
	optionsStart,
	optionsCoordinadorsSuccess,
	optionsLanguagesSuccess,
	optionsColorsSuccess,
	optionsLevelsSuccess,
	optionsTeachersSuccess,
	optionsAccountsBankSuccess,
	optionsCourseListSuccess,
	optionsCourseListOpenByIdUserSuccess,
	optionsCourseIdentifiersSuccess,
	optionsAdminUserSuccess,
	optionsFailure,
	optionsSearchStudentNotInCourseStart,
	optionsSearchStudentNotInCourseSuccess,
	optionsSearchStudentNotInCourseFailure,
} = optionsSlice.actions;
export default optionsSlice.reducer;